import request from "../utils/request";

export const getSuits = '/suit/'

export function getAllSuits() {
    return request.get(getSuits+'?status=true');
}
export function modifySuit(values: any) {
    return request.request({
        url: '/suit/',
        method: values.id ? 'put' : 'post',
        data: values
    });
}

export function deleteSuit(id: number) {
    return request.delete('/suit/', {params: {id}});
}

export function getSuit(id: number) {
    return request.get('/suit/getSuit', {params: {id}})
}
export function getSuitWithGiveaways(id:number){
    return request.get('/suit/getSuitWithGiveaways', {params:{id}});
}

export function updateStatus(id:number, status: boolean) {
    return request.post('/suit/updateStatus', {id,status});
}